/* GES Engine 01 · JD1 favorites: compatible storage/API, Shopify market prices. */
(() => {
  'use strict';
  if (window.__pfFavoritesLoaded) return;
  window.__pfFavoritesLoaded = true;
  const KEY = 'pf-favorites', EVT = 'pf-favorites:update', DAY = 86400000;
  let memory = [], memoryOnly = false, renderController, opener, toastTimer;
  const drawer = () => document.getElementById('pf-fav-drawer');
  const root = () => (window.Shopify?.routes?.root || drawer()?.dataset.rootUrl || '/').replace(/\/?$/, '/');
  const route = path => root() + path;
  const text = (key, fallback) => drawer()?.dataset[key] || fallback;
  const label = (english, spanish) => (document.documentElement.lang || 'en').startsWith('es') ? spanish : english;
  const productUrl = rec => rec.handle ? route('products/' + encodeURIComponent(rec.handle)) : route('collections/all');
  const safeImage = src => { try { const u = new URL(src, location.href); return /^https?:$/.test(u.protocol) ? u.href : ''; } catch { return ''; } };
  function normalize(item) {
    if (typeof item === 'string') item = /^\d+$/.test(item) ? { id: item } : { handle: item };
    if (!item || typeof item !== 'object') return null;
    let handle = String(item.handle || '');
    if (!handle && item.url) { try { handle = decodeURIComponent(new URL(item.url, location.href).pathname.split('/products/')[1]?.split('/')[0] || ''); } catch {} }
    const rec = { id: String(item.id || ''), handle, title: String(item.title || handle), url: '', image: item.image ? safeImage(item.image) : '', price: String(item.price || ''), variantId: String(item.variantId || ''), addedAt: Number(item.addedAt) > 0 ? Number(item.addedAt) : Date.now() };
    if (!rec.id && !rec.handle) return null;
    rec.url = productUrl(rec); return rec;
  }
  const same = (a, b) => Boolean((a.id && b.id && a.id === b.id) || (a.handle && b.handle && a.handle === b.handle));
  function read() {
    let raw = memory;
    if (!memoryOnly) { try { raw = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { memoryOnly = true; } }
    const list = [];
    for (const item of Array.isArray(raw) ? raw : []) { const rec = normalize(item); if (rec && !list.some(other => same(rec, other))) list.push(rec); }
    memory = list; return list;
  }
  function write(list) {
    memory = list;
    try { localStorage.setItem(KEY, JSON.stringify(list)); memoryOnly = false; } catch { memoryOnly = true; }
    document.dispatchEvent(new CustomEvent(EVT, { detail: { favorites: list, count: list.length } }));
    return list;
  }
  const API = window.PFFavorites = {
    getAll: read, count: () => read().length,
    has: item => { const rec = normalize(item); return rec ? read().some(x => same(rec, x)) : false; },
    add: item => { const rec = normalize(item), list = read(); if (rec && !list.some(x => same(rec, x))) list.push({ ...rec, addedAt: Date.now() }); return write(list); },
    remove: item => { const rec = normalize(item); return write(read().filter(x => !rec || !same(rec, x))); },
    toggle: item => API.has(item) ? API.remove(item) : API.add(item), clear: () => write([])
  };
  function recordFrom(el) {
    const d = el.dataset, rec = normalize({ id: d.pfFavId, handle: d.pfFavHandle, title: d.pfFavTitle, url: d.pfFavUrl, image: d.pfFavImage, price: d.pfFavPrice, variantId: d.pfFavVariant });
    if (rec && !el.closest('product-card')) {
      const form = el.closest('.product-information, .shopify-section')?.querySelector('product-form-component input[name="id"]');
      if (form?.value) rec.variantId = form.value;
    }
    return rec;
  }
  function sync(rootNode = document) {
    const list = read(), buttons = [...rootNode.querySelectorAll('[data-pf-fav-toggle]')];
    if (rootNode.matches?.('[data-pf-fav-toggle]')) buttons.push(rootNode);
    for (const btn of buttons) {
      const rec = recordFrom(btn), active = Boolean(rec && list.some(item => same(item, rec)));
      btn.classList.toggle('is-active', active); btn.setAttribute('aria-pressed', String(active));
      const name = active ? btn.dataset.pfLabelOn : btn.dataset.pfLabelOff; if (name) btn.setAttribute('aria-label', name);
    }
    for (const el of document.querySelectorAll('[data-pf-fav-count], #pf-fav-drawer-count')) {
      el.textContent = list.length > 99 ? '99+' : String(list.length); el.classList.toggle('is-empty', !list.length);
      el.closest('[data-pf-fav-bubble]')?.classList.toggle('hidden', !list.length);
    }
  }
  function node(tag, cls, value) { const el = document.createElement(tag); el.className = cls; if (value !== undefined) el.textContent = value; return el; }
  function hideToast() {
    clearTimeout(toastTimer); const el = document.getElementById('pf-fav-toast');
    if (el) { el.hidden = true; el.classList.remove('is-visible'); }
  }
  function showToast(rec) {
    if (['0', 'false'].includes(drawer()?.dataset.toastOnAdd)) return;
    const el = document.getElementById('pf-fav-toast'); if (!el) return;
    const icon = el.querySelector('.pf-fav-toast__icon');
    if (icon && !icon.firstChild) icon.append(document.getElementById('pf-fav-ico-tpl')?.content.cloneNode(true) || '');
    el.querySelector('.pf-fav-toast__msg').textContent = rec.title + ' ' + text('toastText', label('added to your list', 'se agregó a tu lista'));
    const action = el.querySelector('.pf-fav-toast__action');
    action.textContent = text('toastAction', label('View my list', 'Ver mi lista')); action.hidden = false;
    el.hidden = false; el.classList.add('is-visible'); clearTimeout(toastTimer); toastTimer = setTimeout(hideToast, 3200);
  }
  function ageText(added) {
    try { return new Intl.RelativeTimeFormat(document.documentElement.lang || 'en', { numeric: 'auto' }).format(-Math.max(0, Math.floor((Date.now() - added) / DAY)), 'day'); } catch { return ''; }
  }
  function makeItem(rec) {
    const li = node('li', 'pf-fav-item'), main = node('div', 'pf-fav-item__main'), link = node('a', 'pf-fav-item__link');
    link.href = productUrl(rec);
    if (rec.variantId) { const url = new URL(link.href); url.searchParams.set('variant', rec.variantId); link.href = url.href; }
    if (rec.image) { const img = node('img', 'pf-fav-item__img'); img.src = rec.image; img.alt = rec.title; img.loading = 'lazy'; img.width = 88; img.height = 88; link.append(img); }
    const info = node('span', 'pf-fav-item__info'), price = node('span', 'pf-fav-item__price');
    price.dataset.favPrice = ''; // A stored amount may belong to another market. Wait for Shopify.
    info.append(node('span', 'pf-fav-item__title', rec.title || rec.id), price, node('span', 'pf-fav-item__time', ageText(rec.addedAt)));
    link.append(info);
    const remove = node('button', 'pf-fav-item__remove button-unstyled', '×'); remove.type = 'button';
    remove.dataset.pfFavRemove = ''; remove.dataset.pfFavHandle = rec.handle; remove.dataset.pfFavId = rec.id;
    remove.setAttribute('aria-label', text('removeLabel', label('Remove from list', 'Quitar de la lista')) + ': ' + rec.title);
    main.append(link, remove); li.append(main);
    const actions = node('div', 'pf-fav-item__actions'); actions.dataset.favActions = '';
    const view = node('a', 'pf-fav-item__add', label('View product', 'Ver producto')); view.href = link.href;
    actions.append(view); li.append(actions);
    const days = Number(drawer()?.dataset.couponDays || 0), code = drawer()?.dataset.couponCode;
    if (days > 0 && code && Date.now() - rec.addedAt >= days * DAY) {
      const row = node('div', 'pf-fav-item__coupon');
      const message = text('couponText', label('Use [code] at checkout.', 'Usa [code] al finalizar tu compra.')).replace(/\[days\]|\{days\}/g, days).replace(/\[code\]|\{code\}/g, code);
      row.append(node('span', 'pf-fav-item__coupon-text', message));
      const copy = node('button', 'pf-fav-item__coupon-code button-unstyled', code);
      copy.type = 'button'; copy.dataset.pfFavCopy = ''; copy.dataset.code = code; row.append(copy); li.append(row);
    }
    return li;
  }
  async function hydrate(rec, li, signal) {
    if (!rec.handle) return;
    const url = new URL(productUrl(rec), location.href); url.searchParams.set('section_id', 'jd1-favorite-product');
    if (rec.variantId) url.searchParams.set('variant', rec.variantId);
    try {
      const response = await fetch(url, { signal, credentials: 'same-origin' }); if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html'), source = html.querySelector('[data-favorite-product]');
      if (!source || signal.aborted || !li.isConnected) return;
      const data = JSON.parse(source.dataset.favoriteProduct);
      if ((rec.id && String(data.id) !== rec.id) || (rec.variantId && String(data.variantId) !== rec.variantId)) return;
      const price = html.querySelector('[data-favorite-price]');
      if (price) li.querySelector('[data-fav-price]').replaceChildren(price.content.cloneNode(true));
      if (data.title) li.querySelector('.pf-fav-item__title').textContent = data.title;
      const img = li.querySelector('img'); if (img && data.image && safeImage(data.image)) img.src = safeImage(data.image);
      // Gift cards, subscriptions, unchosen options and custom purchase flows remain in the GES PDP.
      if (!data.available || data.requiresPdp || (!rec.variantId && data.variantCount > 1)) return;
      const add = node('button', 'pf-fav-item__add', text('addLabel', label('Add to cart', 'Agregar al carrito')));
      add.type = 'button'; add.dataset.pfFavAdd = ''; add.dataset.variant = String(data.variantId); add.dataset.quantity = String(data.quantityMin || 1);
      add.dataset.pfFavHandle = rec.handle; add.dataset.pfFavId = String(data.id);
      li.querySelector('[data-fav-actions]').replaceChildren(add);
    } catch { /* A working PDP link remains if the market or variant cannot be verified. */ }
  }
  async function renderDrawer() {
    renderController?.abort(); renderController = new AbortController();
    const signal = renderController.signal, body = document.getElementById('pf-fav-drawer-body'); if (!body) return;
    const items = read(); sync();
    if (!items.length) {
      const empty = node('div', 'pf-fav-empty'), icon = node('span', 'pf-fav-empty__icon'), template = document.getElementById('pf-fav-ico-tpl');
      if (template) icon.append(template.content.cloneNode(true));
      empty.append(icon, node('p', 'pf-fav-empty__text', text('emptyText', label('Your list is empty. Save a product to find it here.', 'Tu lista está vacía. Guarda un producto para verlo aquí.'))));
      body.replaceChildren(empty); return;
    }
    const ul = node('ul', 'pf-fav-list'), rows = items.map(makeItem); ul.append(...rows); body.replaceChildren(ul);
    let index = 0;
    await Promise.all(Array.from({ length: Math.min(3, items.length) }, async () => {
      while (index < items.length && !signal.aborted) { const i = index++; await hydrate(items[i], rows[i], signal); }
    }));
  }
  function openDrawer(trigger) {
    const d = drawer(); if (!d) return; bindDrawer(); opener = trigger || document.activeElement;
    hideToast(); renderDrawer(); if (!d.open) d.showModal(); document.documentElement.classList.add('pf-fav-scroll-lock');
  }
  function closeDrawer() { renderController?.abort(); drawer()?.close(); document.documentElement.classList.remove('pf-fav-scroll-lock'); }
  function bindDrawer() {
    const d = drawer(); if (!d || d.dataset.gesBound) return; d.dataset.gesBound = 'true';
    d.addEventListener('click', event => {
      if (event.target !== d) return; const r = d.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeDrawer();
    });
    d.addEventListener('close', () => {
      renderController?.abort(); document.documentElement.classList.remove('pf-fav-scroll-lock');
      if (!document.querySelector('dialog[open]') && opener?.isConnected) opener.focus({ preventScroll: true });
    });
  }
  async function addToCart(button) {
    if (button.disabled || !/^\d+$/.test(button.dataset.variant || '')) return;
    button.disabled = true; button.setAttribute('aria-busy', 'true'); button.textContent = text('addingLabel', label('Adding…', 'Agregando…'));
    const quantity = Math.max(1, Number(button.dataset.quantity) || 1);
    const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId))].slice(0, 5);
    let added;
    try {
      const response = await fetch(route('cart/add.js'), { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: button.dataset.variant, quantity }], sections, sections_url: location.pathname }) });
      added = await response.json();
      if (!response.ok || added.status) throw new Error(added.description || added.message || text('addErrorLabel', label('Unable to add this item. Please retry.', 'No pudimos añadir este producto. Reintenta.')));
    } catch (error) {
      button.disabled = false; button.removeAttribute('aria-busy'); button.textContent = text('addLabel', label('Add to cart', 'Agregar al carrito'));
      const status = node('p', 'pf-fav-item__error', error.message); status.setAttribute('role', 'alert');
      button.parentElement.querySelector('.pf-fav-item__error')?.remove(); button.parentElement.append(status); return;
    }
    // Confirmed POST: a refresh failure must not offer a duplicate add.
    closeDrawer(); API.remove({ id: button.dataset.pfFavId, handle: button.dataset.pfFavHandle });
    let cart;
    try { const response = await fetch(route('cart.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' } }); if (response.ok) cart = await response.json(); } catch {}
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart || added, sourceId: 'pf-favorites',
      data: { source: cart ? 'pf-favorites' : 'product-form-component', itemCount: cart ? cart.item_count : quantity, sections: added.sections } } }));
  }
  async function copyCode(button) {
    try { await navigator.clipboard.writeText(button.dataset.code); const prev = button.textContent; button.textContent = text('copiedText', label('Copied!', '¡Copiado!')); setTimeout(() => { button.textContent = prev; }, 1600); }
    catch { button.textContent = button.dataset.code; }
  }
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const toggle = event.target.closest('[data-pf-fav-toggle]');
    if (toggle) { event.preventDefault(); event.stopPropagation(); const rec = recordFrom(toggle); if (!rec) return; const had = API.has(rec); API.toggle(rec); if (!had) showToast(rec); return; }
    const open = event.target.closest('[data-pf-fav-open]'); if (open) { event.preventDefault(); openDrawer(open); return; }
    if (event.target.closest('[data-pf-fav-close]')) { event.preventDefault(); closeDrawer(); return; }
    const remove = event.target.closest('[data-pf-fav-remove]');
    if (remove) { event.preventDefault(); API.remove({ id: remove.dataset.pfFavId, handle: remove.dataset.pfFavHandle }); drawer()?.querySelector('.pf-fav-item__remove, .pf-fav-drawer__close')?.focus(); return; }
    const add = event.target.closest('[data-pf-fav-add]'); if (add) { event.preventDefault(); addToCart(add); return; }
    const copy = event.target.closest('[data-pf-fav-copy]'); if (copy) { event.preventDefault(); copyCode(copy); }
  });
  document.addEventListener(EVT, () => { sync(); if (drawer()?.open) renderDrawer(); });
  window.addEventListener('storage', event => { if (event.key !== KEY && event.key !== null) return; memoryOnly = false; sync(); if (drawer()?.open) renderDrawer(); });
  function init() { bindDrawer(); sync(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => { const d = drawer(); if (d && event.target.contains(d)) { renderController?.abort(); document.documentElement.classList.remove('pf-fav-scroll-lock'); } });
  window.addEventListener('pageshow', init);
  new MutationObserver(records => {
    for (const mutation of records) for (const el of mutation.addedNodes) {
      if (el.nodeType !== 1) continue;
      if (el.matches('[data-pf-fav-toggle]') || el.querySelector('[data-pf-fav-toggle]')) sync(el);
      if (el.id === 'pf-fav-drawer' || el.querySelector('#pf-fav-drawer')) bindDrawer();
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
